<template>
  <div class="the-hot">
    <div>
        <el-button class="open-new-session" @click="onOpenNewSession">
          <i class="ri-chat-voice-ai-line"></i>
          开启新对话
        </el-button>
    </div>
    <div class="title">
      <div class="text">历史记录</div>
      <div class="clear" @click="clean">清空</div>
      <!-- <img src="@img/clean.png" alt="" srcset="" @click="clean"> -->
    </div>
    <div class="list">
      <div class="session-history-item" v-for="(item, index) in sessionHistory" :key="index + item" >
        <template v-if="item.list.length">
          <div class="session-time">{{item.date | formatDateFiled}}</div>
          <div class="session-item item" v-for="(session) of item.list" :key="session.id" @click="onClick(session)">
            <!-- <img src="@img/clock.png"> -->
            <span class="text" :title="session.chatMessages[1].content">{{ session.chatMessages[1].content }}</span>

            <div class="session-item__tools" @click.stop>
              <span class="session-item__tool-icon">
                <i class="ri-delete-bin-line" @click="onDelSessionItem(session)"></i>
              </span>
              <!-- <el-dropdown size="medium" trigger="click" placement="bottom-start">
                <span class="session-item__tool-icon">
                  <i class="el-icon-more"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item class="session-item__del" @click.native="onDelSessionItem(session)"><i class="el-icon-delete"></i> 删除</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown> -->
            </div>
          </div>
        </template>
      </div>
      <div class="more-history">显示更多 <img src="../assets/img/index/more.png" alt=""></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "the-history",
  mixins: [],
  props: {
    list: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  components: {},
  filters: {
    formatDateFiled (value) {
      const dist = {
        'today': '今天',
        'yesterday': '昨天',
        'last30day': '30天内',
        'out30day': '30天外'
      }
      return dist[value]
    }
  },
  computed: {
    sessionHistory () {

      var data = {
        'today': [],
        'yesterday': [],
        'last30day': [],
        'out30day': []
      };

      // 处理 list 数据结构, 区分今天，昨天，30天内，30天外
      this.list.forEach((item) => {
        if(this.isToday(item.timestamp)) {
          data.today.push(item)
        } else if(this.isYesterday(item.timestamp)) {
          data.yesterday.push(item)
        } else if(this.isLast30Day(item.timestamp)) {
          data.last30day.push(item)
        } else {
          data.out30day.push(item)
        }
      })

      // 排序，时间近的靠前
      var newList = [];
      for (let key in data) {
        newList.push({
          date: key,
          list: this.sortByTime(data[key])
        })
      }
      return newList
    },
  },
  data() {
    return {

    }
  },
  methods: {
    onOpenNewSession () {
      this.$emit('openNewSession')
    },
    sortByTime(list) {
      return list.sort((a, b) => {
        return a.timestamp - b.timestamp
      })
    },
    onDelSessionItem (session) {
      this.$emit('delSessionItem', session.id)
    },
    isToday(timestamp) {
        const date = new Date(timestamp);
        const now = new Date();
        return date.getFullYear() === now.getFullYear() && date.getMonth() === now.getMonth() && date.getDate() === now.getDate()
    },
    isYesterday(timestamp) {
        const date = new Date(timestamp);
        const now = new Date();
        return date.getFullYear() === now.getFullYear() && date.getMonth() === now.getMonth() && date.getDate() === now.getDate() - 1
    },
    isLast30Day(timestamp) {
        const date = new Date(timestamp);
        const now = new Date();
        return date.getFullYear() === now.getFullYear() && date.getMonth() === now.getMonth() && date.getDate() >= now.getDate() - 30
    },
    onClick(item) {
      this.$emit('click', item)
    },
    clean() {
      this.$emit('clearClick')
    }
  },
  mounted() { }
}
</script>

<style lang="scss" scoped>
@import '~@/assets/css/_var.scss';

.the-hot {
  padding: 12px 12px 0 20px;

  .title {
    font-size: 18px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .text{
      cursor: pointer;
    }
    .clear{
      font-family: PingFang SC;
      font-weight: 400;
      font-size: 14px;
      line-height: 100%;
      letter-spacing: 0%;
      color: #96a4ac;
      cursor: pointer;
    }
    img {
      transform: scale(1);
      transition: .2s ease-in-out;

      &:hover {
        transform: scale(1.2);
        transition: .2s ease-in-out;
      }
    }
  }

  .open-new-session {
    color: #fff;
    background: linear-gradient(90deg, #00A6FF 0%, #3146FF 100%);
    border: none;
    border-radius: 4px;
    margin-top: 10px;
    margin-bottom: 12px;
    font-size: 16px;
    padding: 10px 18px;
    width: 100%;
    height: 42px;
    &:hover {
      // background: #c6dcf8;
    }
    i{
      font-size: 20px;
    }
  }

  .list {
    min-height: 140px;
    height: auto;
    //max-height: 264px;
    max-height: calc(100vh - 467px);
    overflow-y: auto;
    &::-webkit-scrollbar {
      display: none; /* Chrome, Safari, and newer versions of Edge */
    }
    .session-history-item {
      .session-time {
        font-size: 14px;
        margin-top: 20px;
        margin-bottom: 14px;
        padding-left: 5px;
      }
    }

    .item {
      display: flex;
      align-items: center;
      opacity: 1;
      border-radius: 4px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      padding: 4px 5px;
      cursor: pointer;
      transition: .2s ease-in-out;
      &:hover{
        background: rgba(189, 211, 255, 0.2);
      }
      img {
        margin-right: 10px;
      }

      .text {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        color: rgba(78, 85, 135, 1);
        font-size: var(--font-size);
      }

      &+.item {
        margin-top: 4px;
      }

      &:hover {
        transition: .2s ease-in-out;
        background: rgba(189, 211, 255, 0.8);
      }

      .session-item__tools {
        margin-left: auto;
        .session-item__tool-icon {
          display: inline-block;
          padding: 6px;
          color:#e53535 ;
        }
      }
      
    }
    .more-history{
      color: #4550b9;
      display: flex;
      align-items: center;
      font-family: PingFang SC;
      font-weight: 400;
      font-size: 14px;
      line-height: 100%;
      letter-spacing: 0%;
      padding-left: 5px;
      margin-top: 10px;
    }
  }
}

::v-deep .session-item__del {
  color: #e53535;
  &:hover {
    color: #e53535;
    background: rgba(184, 92, 92, 0.16);
  }
}

</style>
